'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const PageStatusTokenContext = /*#__PURE__*/ React.createContext(undefined);
const PageStatusTokenSetter = /*#__PURE__*/ React.createContext(undefined);
export function PageStatusTokenProvider({ children, value: defaultPageStatusToken }) {
    const [pageStatusToken, setPageStatusToken] = React.useState(defaultPageStatusToken);
    const pageStatusTokenSetter = React.useCallback((value)=>{
        setPageStatusToken(value);
    }, []);
    return /*#__PURE__*/ _jsx(PageStatusTokenContext, {
        value: pageStatusToken,
        children: /*#__PURE__*/ _jsx(PageStatusTokenSetter, {
            value: pageStatusTokenSetter,
            children: children
        })
    });
}
export default function usePageStatusToken() {
    const context = React.use(PageStatusTokenContext);
    if (context === undefined) {
        throw new Error('usePageStatusToken must be used within a PageStatusTokenProvider');
    }
    return context;
}
export function useSetPageStatusToken() {
    const context = React.use(PageStatusTokenSetter);
    if (context === undefined) {
        throw new Error('useSetPageStatusToken must be used within a PageStatusTokenProvider');
    }
    return context;
}
export function usePageStatusTokenAtom() {
    return [
        usePageStatusToken(),
        useSetPageStatusToken()
    ];
}

//# sourceMappingURL=pageStatusTokenAtom.js.map